import Backbone from 'backbone'
import template from './org-permissions-audit-table.hbs'
import _ from 'lodash'

import {
    renderGroup,
    renderUsers,
    renderGroupActions,
    renderRollupTreeGroup,
    onClickRollupTreeGroup,
} from '../permissions-audit-util';

import GroupGrantType from './group-grant-type'
const { EXPLICIT, IMPLICIT, VIEW_ALL, ROLLUP_TREE_GROUP } = GroupGrantType
import i18n from '../../components/i18n'

const OrgPermissionsAuditTable = Backbone.View.extend(/** @lends {OrgPermissionsAuditTable} */{

	events: {
		'click .template': 'onClickRollupTreeGroup'
	},

	/**
	 * For the Organization Permissions Audit (#54663) this is the table that
	 * displays the results. Also used to display the results for datasets with
	 * standard permissions for the Dataset Permissions Audit (#54664).
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Object} options.response the response from the server
	 *
	 * @param {Number} options.organizationId the ID of the organization
	 */
	initialize: function(options = {}) {
		this.options = options
		this.response = options.response
	},

	render: function() {
		this.$el.html(template())

		if (_.isNil(this.response)) return

		this.toggle()
		this.$('.panel-with-table').removeClass('is-not-displayed')

		this.orgsById = _.keyBy(this.response.organizations, 'id')
		this.groupsById = _.keyBy(this.response.groups, 'id')
		this.rollupTreeGroupsById = _.keyBy(this.response.rollupTreeGroups, 'id')

		this.renderTable()

		return this
	},

	renderTable: function() {
		let html = ''
		_.each(this.getSortedPermissions(), op => {
			html +=
				'<tr>' +
					'<td>' + this.renderPermissionSource(op) + '</td>' + // Permission Source
					'<td>' + renderUsers(this.response.users, op.userIds) + '</td>' + // Users
					'<td>' + this.renderPermissionType(op) + '</td>' +
					'<td>' + renderGroupActions(op.permissionIds) + '</td>' +
				'</tr>'
		})
		this.$('table tbody').html(html)
	},

	/**
	 * Sorts the permissions first by all groups A to Z, then all rollup
	 * templates A to Z.
	 */
	getSortedPermissions: function() {
		return _.sortBy(this.response.permissions, permission => {
			return this.groupsById[permission.groupId]?.label.toLocaleLowerCase()
		})
	},

	/**
	 * @param permission see OrgPermissionsAuditPermission.kt
	 */
	renderPermissionSource: function(permission) {
		if (permission.rollupTreeGroupId) {
			let template = this.rollupTreeGroupsById[permission.rollupTreeGroupId]
			return renderRollupTreeGroup({
				rollupTreeGroupId: permission.rollupTreeGroupId,
				rollupTreeGroupLabel: template?.label,
				treeRootId: template?.treeRootId,
				organizationId: this.options.organizationId
			})
		} else {
			return renderGroup(this.groupsById[permission.groupId])
		}
	},

	renderPermissionType: function({ grantType, grantedOrgId }) {
		let keys = {
			[EXPLICIT]: 'admin.orgPermissionsAudit.directPermission',
			[IMPLICIT]: 'admin.orgPermissionsAudit.cascadePermission',
			[VIEW_ALL]: 'admin.orgPermissionsAudit.allOrgsPermission',
			[ROLLUP_TREE_GROUP]: 'datasets.rollupTreeGroup'
		}
		let org = this.orgsById[grantedOrgId]
		return _.escape(i18n.get(keys[grantType], org?.label))
	},

	/**
	 * Toggles the display of the table and the "No results" message.
	 */
	toggle: function() {
		let hasPermissions = !_.isEmpty(this.response.permissions)
		this.$('.no-permissions').toggleClass('is-not-displayed', hasPermissions)
		this.$('.panel-with-table').toggleClass('is-not-displayed', !hasPermissions)
	},

	onClickRollupTreeGroup,

	autoRemove: true

})

export default OrgPermissionsAuditTable

OrgPermissionsAuditTable.__filename__ = 'admin/org-permissions-audit/org-permissions-audit-table.js'
